import classNames from "classnames";

export function MiniButton(props) {
  const color = props.color ?? "primary";

  return (
    <button
      className={classNames(
        "text-xs transition-colors text-white p-1 rounded leading-none font-normal block",
        {
          "bg-primary hover:bg-primaryHover": color === "primary",
          "bg-blue hover:bg-[#306abc]": color === "primary-light",
          "bg-lightRed hover:bg-lightRedHover": color === "danger",
        },
        props.className
      )}
      {...props}
    >
      {props.children}
    </button>
  );
}
